import React from "react";
// import Logo from "../../icons.svg";
// import Nav from "../Nav/Nav";
import "./Main.css";

function Main() {

//for future plans!!!!! fun stuff!!!!

  //   const sections = document.querySelectorAll("section");
  //   const bubble = document.querySelector(".bubble");
  //   const color = ["#F27405"];

  //   const options = {
  //     threshold: 0.7,
  //   };

  //   let observer = new IntersectionObserver(navCheck, options);

  //   function navCheck(entries) {
  //     entries.forEach((entry) => {
  //       const classNames = entry.target.classNames;
  //       const activeAnchor = document.querySelector(`[data-page=${classNames}]`);
  //       const colorIndex = entry.target.getAttribute("data-index");
  //       const coords = activeAnchor.getBoundingClientRect();
  //       const dirctions = {
  //         height: coords.height,
  //         width: coords.width,
  //         top: coords.top,
  //         left: coords.left,
  //       };
  //       if (entry.isIntersecting) {
  //         bubble.style.setProperty("left", `${dirctions.left}px`);
  //         bubble.style.setProperty("top", `${dirctions.top}px`);
  //         bubble.style.setProperty("width", `${dirctions.width}px`);
  //         bubble.style.setProperty("height", `${dirctions.hight}px`);
  //         bubble.style.background = color(colorIndex);
  //       }
  //     });
  //   }

  //   sections.forEach((section) => {
  //     observer.observe(section);
  //   });

  return (
    <div>
      <header>
        <nav className="navbar">
          <ul className="navbar--link">
            <li className="navbar--link-item">
              <a data-page="about" href="#about">
                About
              </a>
            </li>
            <li className="navbar--link-item">
              <a data-page="projects" href="#projects">
                Projects
              </a>
            </li>
            <li className="navbar--link-item">
              <a data-page="contact" href="#contact">
                Contact
              </a>
            </li>
            <div className="bubble"></div>
          </ul>
        </nav>
      </header>

      <main>

        <section id="about" data-index="0" className="container-fluid about">
          <div className="row">
            <div id="col-1" className="col-6">
              <a href="http://masonstafford.com/files/Mason-Stafford-Web-Developer.pdf" target="_blank" rel="noopener noreferrer"><img className="img-me" src={require("../../img/masonprofile.jpg")} alt="me" /></a>
            </div>
            <div id="col-2" className="col-6 webDev">
              <div className="name-move">
                <h5 className="name">Mason Stafford</h5>
                <hr></hr>
              </div>
              <h1 className="me1">Full-Stack</h1>
              <h1 className="me2">Web Developer</h1>
              <p className="p1">
                Hello friends! I am a Full-Stack Web Developer from
                <br /> Charlotte, North Carolina. I love coding,
                <br /> designing web applications and learning
                <br />
                new things!
              </p>
            </div>
          </div>
        </section>

        <section
          data-index="1"
          className="container-fluid projects"
          id="projects"
        >
          <div className="row">

            <div className="col-12">
                <h1 id="projects">Projects</h1>
                <hr id="hr"></hr>
            </div>

            <div id="col-3-4" className="col-12">
              <div class="container">
                <div class="card">
                  <h3 class="title">SneakersWithStories</h3>
                  <div class="bar">
                    <div class="emptybar"></div>
                    <div class="filledbar"></div>
                    <p className="description">Sneakers with Stories is a non-profit based out of Charlotte, NC that helps people visualize their stories in a new way. You guessed it - Through sneakers!</p>
                    <div className="btn-container">
                      <button id="btn btn1" type="button" className="btn btn1 btn-outline-secondary"><a id="href-btn" href="https://safe-beyond-09344.herokuapp.com/" target="_blank" rel="noopener noreferrer">Go To Site!</a></button>
                      <button id="btn btn1" type="button" className="btn btn1 btn-outline-secondary"><a id="href-btn" href="https://github.com/jethan16/SneakersWithStories" target="_blank" rel="noopener noreferrer">GitHub!</a></button>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <h3 class="title">Event Application</h3>
                  <div class="bar">
                    <div class="emptybar"></div>
                    <div class="filledbar"></div>
                    <p className="description">Event Application allows the user to search events in various categories. The user can also sign up and log in if they would like to fill out a form to plan a new event. Happy planning!</p>
                    <div className="btn-container">
                      <button id="btn btn2" type="button" className="btn btn2 btn-outline-secondary"><a id="href-btn" href="https://eventcom.herokuapp.com/" target="_blank" rel="noopener noreferrer">Go To Site!</a></button>
                      <button id="btn btn2" type="button" className="btn btn2 btn-outline-secondary"><a id="href-btn" href="https://github.com/masonstafford/eventplanner" target="_blank" rel="noopener noreferrer">GitHub!</a></button>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <h3 class="title">Team Info</h3>
                  <div class="bar">
                    <div class="emptybar"></div>
                    <div class="filledbar"></div>
                    <p className="description">Team Profile Generator (CLI) will prompt the user with questions based on the employee role you are filling out: manager, engineer or intern. Once filled out, it will generate a web page with all the given information.</p>
                    <div className="btn-container">
                      <button id="btn btn3" type="button" className="btn btn3 btn-outline-secondary"><a id="href-btn" href="https://github.com/masonstafford/Team-Info" target="_blank" rel="noopener noreferrer">GitHub!</a></button>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <h3 class="title">Employee Directory</h3>
                  <div class="bar">
                    <div class="emptybar"></div>
                    <div class="filledbar"></div>
                    <p className="description">Employee Directory allows the user to search through employees by name. Type in the search bar, it will auto update the employees who appear based on the letters in the particular employee’s name.</p>
                    <div className="btn-container">
                      <button id="btn btn4" type="button" className="btn btn4 btn-outline-secondary"><a id="href-btn" href="https://protected-brushlands-70889.herokuapp.com/" target="_blank" rel="noopener noreferrer">Go To Site!</a></button>
                      <button id="btn btn4" type="button" className="btn btn4 btn-outline-secondary"><a id="href-btn" href="https://github.com/masonstafford/Employee-Directory" target="_blank" rel="noopener noreferrer">GitHub!</a></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="contact"
          data-index="2"
          className="container-fluid contact"
        >
          <div id="row" className="row">
            <div id="col-5" className="col-6 links">
              <h1 className="conme">Contact me.</h1>
              <svg
                id="icons1"
                width="403"
                height="76"
                viewBox="0 0 423 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="icons">
                  <a
                    href="https://www.linkedin.com/in/masonstafford/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <g id="linkedin">
                      <rect
                        id="Rectangle 7"
                        x="323"
                        width="100"
                        height="96"
                        rx="10"
                        fill="#2B3440"
                      />
                      <path
                        id="Vector"
                        d="M393.452 23H351.548C347.933 23 345 25.6667 345 28.9524V67.0476C345 70.3333 347.933 73 351.548 73H393.452C397.067 73 400 70.3333 400 67.0476V28.9524C400 25.6667 397.067 23 393.452 23ZM362.024 42.0476V64.6667H354.167V42.0476H362.024ZM354.167 35.4643C354.167 33.7976 355.738 32.5238 358.095 32.5238C360.452 32.5238 361.932 33.7976 362.024 35.4643C362.024 37.131 360.557 38.4762 358.095 38.4762C355.738 38.4762 354.167 37.131 354.167 35.4643ZM390.833 64.6667H382.976C382.976 64.6667 382.976 53.6429 382.976 52.7619C382.976 50.381 381.667 48 378.393 47.9524H378.288C375.119 47.9524 373.81 50.4048 373.81 52.7619C373.81 53.8452 373.81 64.6667 373.81 64.6667H365.952V42.0476H373.81V45.0952C373.81 45.0952 376.337 42.0476 381.418 42.0476C386.617 42.0476 390.833 45.2976 390.833 51.881V64.6667Z"
                        fill="#F27405"
                      />
                    </g>
                  </a>
                  <a href="https://github.com/masonstafford" target="_blank" rel="noopener noreferrer">
                    <g id="github">
                      <rect
                        id="Rectangle 6"
                        x="161"
                        width="100"
                        height="96"
                        rx="10"
                        fill="#2B3440"
                      />
                      <path
                        id="Vector_2"
                        d="M221.457 52.2564C218.996 52.2564 217.348 54.3161 217.348 57.6923C217.348 61.0685 218.568 64.5509 221.457 64.4872C224.495 64.4182 225.592 61.4666 225.565 57.6923C225.544 54.3161 223.912 52.2564 221.457 52.2564ZM236.88 36.039C237.255 34.2128 237.415 27.7471 234.713 21C234.713 21 228.508 21.6742 219.124 28.0656C217.161 27.5241 213.828 27.2534 210.5 27.2534C207.172 27.2534 203.845 27.5241 201.871 28.0603C192.492 21.6742 186.292 21 186.292 21C183.585 27.7471 183.719 34.0589 184.12 36.039C180.942 39.4629 179 43.5717 179 49.1881C179 73.6019 199.415 73.9947 204.567 73.9947C205.733 73.9947 208.05 73.9947 210.5 74C212.95 73.9947 215.272 73.9947 216.433 73.9947C221.585 73.9947 242 73.6019 242 49.1881C242 43.5717 240.058 39.4629 236.88 36.039ZM210.693 71.2821H210.5C197.585 71.2821 187.431 69.4612 187.431 57.0075C187.431 54.0241 188.496 51.2584 191.016 48.9598C195.221 45.1271 202.331 47.1549 210.404 47.1549C210.436 47.1549 210.57 47.1549 210.596 47.1549C218.669 47.1549 225.785 45.1324 229.99 48.9598C232.509 51.2584 233.569 54.0241 233.569 57.0075C233.569 69.4612 223.607 71.2821 210.693 71.2821ZM199.543 52.2564C197.088 52.2564 195.435 54.9956 195.435 58.3718C195.435 61.748 197.088 64.4872 199.543 64.4872C202.004 64.4872 203.652 61.748 203.652 58.3718C203.652 54.9956 202.004 52.2564 199.543 52.2564Z"
                        fill="#F27405"
                      />
                    </g>
                  </a>
                  <a
                    href="http://masonstafford.com/files/Mason-Stafford-Web-Developer.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <g id="resume">
                      <rect
                        id="Rectangle 5"
                        width="100"
                        height="96"
                        rx="10"
                        fill="#2B3440"
                      />
                      <path
                        id="Vector_3"
                        d="M40.5882 73H59.4118V49.4615H40.5882V73ZM18 73H36.8235V22H18V73ZM63.1765 73H82V49.4615H63.1765V73ZM40.5882 22V45.5385H82V22H40.5882Z"
                        fill="#F27405"
                      />
                    </g>
                  </a>
                </g>
              </svg>
            </div>
            <div id="col-6" className="col-6">
              <svg
                id="main1"
                width="732"
                height="275"
                viewBox="0 0 782 325"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="main">
                  <g id="cube3-pt2">
                    <path
                      id="cube3-pt2_2"
                      d="M149.14 43.1354H128.912V63.3629H149.14V43.1354Z"
                      fill="#2B3440"
                    />
                  </g>
                  <g id="cube3-pt1">
                    <path
                      id="cube3-pt1_2"
                      d="M161.422 51.8043H136.859V27.2423H161.422V51.8043ZM137.927 50.7364H160.354V28.3102H137.927V50.7364Z"
                      fill="#F27405"
                    />
                  </g>
                  <g id="cube2-pt2">
                    <path
                      id="cube2-pt2"
                      d="M58.7591 125.104L53.2048 105.654L33.7539 111.208L39.3082 130.658L58.7591 125.104Z"
                      fill="#2B3440"
                    />
                  </g>
                  <g id="cube2-pt1">
                    <path
                      id="cube2-pt1_2"
                      d="M53.7952 139.293L47.0508 115.675L70.6697 108.931L77.4142 132.549L53.7952 139.293ZM48.3709 116.409L54.5289 137.973L76.0941 131.815L69.9361 110.251L48.3709 116.409Z"
                      fill="#F27405"
                    />
                  </g>
                  <g id="cube1-pt2">
                    <path
                      id="Vector"
                      d="M53.732 34.5146L67.5439 19.7362L52.765 5.92483L38.953 20.7032L53.732 34.5146Z"
                      fill="#2B3440"
                    />
                  </g>
                  <g id="cube1-pt1">
                    <path
                      id="Vector_2"
                      d="M39.0125 37.5681L55.7841 19.6229L73.73 36.3939L56.9584 54.339L39.0125 37.5681ZM55.8352 21.1323L40.5219 37.517L56.9073 52.8296L72.2205 36.4449L55.8352 21.1323Z"
                      fill="#F27405"
                    />
                  </g>
                  <g id="computer">
                    <path
                      id="Vector_3"
                      d="M741.394 3.87381H553.436V0H468.209V3.87381H279.476C277.807 3.87381 276.153 4.20265 274.611 4.84155C273.068 5.48046 271.667 6.41692 270.486 7.59747C269.306 8.77802 268.369 10.1795 267.73 11.722C267.091 13.2645 266.762 14.9176 266.762 16.5872V273.948C266.762 275.618 267.091 277.271 267.73 278.814C268.369 280.356 269.306 281.758 270.486 282.938C271.667 284.119 273.068 285.055 274.611 285.694C276.153 286.333 277.807 286.662 279.476 286.662H741.394C744.766 286.662 747.999 285.322 750.384 282.938C752.768 280.554 754.108 277.32 754.108 273.948V16.5872C754.108 14.9176 753.779 13.2645 753.14 11.722C752.501 10.1795 751.564 8.77802 750.384 7.59747C749.203 6.41692 747.802 5.48046 746.259 4.84155C744.717 4.20265 743.063 3.87381 741.394 3.87381Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_4"
                      d="M737.062 26.3419H283.808V282.013H737.062V26.3419Z"
                      fill="#F27405"
                    />
                    <path
                      id="Vector_5"
                      d="M510.048 19.369C512.615 19.369 514.696 17.2878 514.696 14.7205C514.696 12.1531 512.615 10.0719 510.048 10.0719C507.48 10.0719 505.399 12.1531 505.399 14.7205C505.399 17.2878 507.48 19.369 510.048 19.369Z"
                      fill="#F27405"
                    />
                    <path
                      id="Vector_6"
                      opacity="0.1"
                      d="M607.439 282.013H283.808V26.342L607.439 282.013Z"
                      fill="black"
                    />
                    <path
                      id="Vector_7"
                      d="M354.729 262.881C378.791 262.881 398.297 243.376 398.297 219.315C398.297 195.254 378.791 175.748 354.729 175.748C330.667 175.748 311.16 195.254 311.16 219.315C311.16 243.376 330.667 262.881 354.729 262.881Z"
                      fill="#BACDD9"
                    />
                    <path
                      id="Vector_8"
                      d="M364.427 252.059C353.709 252.059 343.231 248.881 334.318 242.926C325.406 236.971 318.46 228.508 314.358 218.605C310.256 208.703 309.183 197.807 311.274 187.294C313.365 176.782 318.527 167.126 326.106 159.547C333.685 151.968 343.342 146.807 353.854 144.716C364.367 142.625 375.264 143.698 385.167 147.8C395.069 151.901 403.533 158.847 409.488 167.759C415.443 176.671 418.622 187.149 418.622 197.867C418.606 212.235 412.891 226.009 402.731 236.169C392.571 246.328 378.796 252.043 364.427 252.059ZM364.427 144.383C353.849 144.383 343.508 147.52 334.712 153.397C325.916 159.273 319.061 167.626 315.012 177.399C310.964 187.172 309.905 197.926 311.969 208.301C314.033 218.676 319.127 228.206 326.607 235.686C334.087 243.166 343.617 248.259 353.993 250.323C364.368 252.387 375.122 251.328 384.896 247.28C394.669 243.232 403.022 236.376 408.899 227.581C414.777 218.786 417.913 208.445 417.913 197.867C417.897 183.687 412.257 170.092 402.23 160.066C392.203 150.039 378.608 144.399 364.427 144.383Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_9"
                      d="M658.143 164.228H615.804V173.074H658.143V164.228Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_10"
                      d="M709.329 95.3506H564.618V99.142H709.329V95.3506Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_11"
                      d="M709.329 119.363H564.618V123.154H709.329V119.363Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_12"
                      d="M709.329 107.357H564.618V111.148H709.329V107.357Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_13"
                      d="M709.329 131.369H564.618V135.16H709.329V131.369Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_14"
                      d="M709.329 143.375H564.618V147.166H709.329V143.375Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_15"
                      d="M709.329 31.5289H691.635V49.2221H709.329V31.5289Z"
                      fill="#BACDD9"
                    />
                    <path
                      id="Vector_16"
                      d="M717.544 57.4367H696.058V35.9521H717.544V57.4367ZM696.993 56.5026H716.61V36.8863H696.993V56.5026Z"
                      fill="#3F3D56"
                    />
                    <path
                      id="Vector_17"
                      d="M766.834 277.365H722.599V274.178C722.599 274.095 722.583 274.013 722.551 273.936C722.519 273.859 722.473 273.79 722.414 273.731C722.356 273.672 722.286 273.626 722.209 273.594C722.133 273.562 722.05 273.546 721.967 273.546H706.801C706.718 273.546 706.636 273.562 706.559 273.594C706.483 273.626 706.413 273.672 706.354 273.731C706.296 273.79 706.249 273.859 706.217 273.936C706.186 274.013 706.169 274.095 706.169 274.178V277.365H696.69V274.178C696.69 274.095 696.674 274.013 696.642 273.936C696.611 273.859 696.564 273.79 696.505 273.731C696.447 273.672 696.377 273.626 696.3 273.594C696.224 273.562 696.141 273.546 696.058 273.546H680.892C680.809 273.546 680.727 273.562 680.65 273.594C680.574 273.626 680.504 273.672 680.445 273.731C680.387 273.79 680.34 273.859 680.308 273.936C680.277 274.013 680.26 274.095 680.26 274.178V277.365H670.782V274.178C670.782 274.095 670.765 274.013 670.733 273.936C670.702 273.859 670.655 273.79 670.596 273.731C670.538 273.672 670.468 273.626 670.391 273.594C670.315 273.562 670.233 273.546 670.15 273.546H654.983C654.9 273.546 654.818 273.562 654.742 273.594C654.665 273.626 654.595 273.672 654.537 273.731C654.478 273.79 654.431 273.859 654.4 273.936C654.368 274.013 654.352 274.095 654.352 274.178V277.365H644.873V274.178C644.873 274.095 644.856 274.013 644.825 273.936C644.793 273.859 644.746 273.79 644.688 273.731C644.629 273.672 644.559 273.626 644.483 273.594C644.406 273.562 644.324 273.546 644.241 273.546H629.075C628.992 273.546 628.909 273.562 628.833 273.594C628.756 273.626 628.686 273.672 628.628 273.731C628.569 273.79 628.522 273.859 628.491 273.936C628.459 274.013 628.443 274.095 628.443 274.178V277.365H618.964V274.178C618.964 274.095 618.947 274.013 618.916 273.936C618.884 273.859 618.837 273.79 618.779 273.731C618.72 273.672 618.65 273.626 618.574 273.594C618.497 273.562 618.415 273.546 618.332 273.546H603.166C603.083 273.546 603.001 273.562 602.924 273.594C602.847 273.626 602.778 273.672 602.719 273.731C602.66 273.79 602.614 273.859 602.582 273.936C602.55 274.013 602.534 274.095 602.534 274.178V277.365H593.055V274.178C593.055 274.095 593.039 274.013 593.007 273.936C592.975 273.859 592.928 273.79 592.87 273.731C592.811 273.672 592.741 273.626 592.665 273.594C592.588 273.562 592.506 273.546 592.423 273.546H577.257C577.174 273.546 577.092 273.562 577.015 273.594C576.938 273.626 576.869 273.672 576.81 273.731C576.751 273.79 576.705 273.859 576.673 273.936C576.641 274.013 576.625 274.095 576.625 274.178V277.365H567.146V274.178C567.146 274.095 567.13 274.013 567.098 273.936C567.066 273.859 567.02 273.79 566.961 273.731C566.902 273.672 566.833 273.626 566.756 273.594C566.679 273.562 566.597 273.546 566.514 273.546H447.712C447.629 273.546 447.547 273.562 447.471 273.594C447.394 273.626 447.324 273.672 447.266 273.731C447.207 273.79 447.16 273.859 447.129 273.936C447.097 274.013 447.081 274.095 447.081 274.178V277.365H437.602V274.178C437.602 274.095 437.585 274.013 437.554 273.936C437.522 273.859 437.475 273.79 437.417 273.731C437.358 273.672 437.288 273.626 437.212 273.594C437.135 273.562 437.053 273.546 436.97 273.546H421.804C421.721 273.546 421.638 273.562 421.562 273.594C421.485 273.626 421.415 273.672 421.357 273.731C421.298 273.79 421.252 273.859 421.22 273.936C421.188 274.013 421.172 274.095 421.172 274.178V277.365H411.693V274.178C411.693 274.095 411.676 274.013 411.645 273.936C411.613 273.859 411.566 273.79 411.508 273.731C411.449 273.672 411.379 273.626 411.303 273.594C411.226 273.562 411.144 273.546 411.061 273.546H395.895C395.812 273.546 395.729 273.562 395.653 273.594C395.576 273.626 395.507 273.672 395.448 273.731C395.389 273.79 395.343 273.859 395.311 273.936C395.279 274.013 395.263 274.095 395.263 274.178V277.365H385.784V274.178C385.784 274.095 385.768 274.013 385.736 273.936C385.704 273.859 385.658 273.79 385.599 273.731C385.54 273.672 385.47 273.626 385.394 273.594C385.317 273.562 385.235 273.546 385.152 273.546H369.986C369.903 273.546 369.821 273.562 369.744 273.594C369.667 273.626 369.598 273.672 369.539 273.731C369.48 273.79 369.434 273.859 369.402 273.936C369.37 274.013 369.354 274.095 369.354 274.178V277.365H359.875V274.178C359.875 274.095 359.859 274.013 359.827 273.936C359.795 273.859 359.749 273.79 359.69 273.731C359.631 273.672 359.562 273.626 359.485 273.594C359.408 273.562 359.326 273.546 359.243 273.546H344.077C343.994 273.546 343.912 273.562 343.835 273.594C343.758 273.626 343.689 273.672 343.63 273.731C343.571 273.79 343.525 273.859 343.493 273.936C343.461 274.013 343.445 274.095 343.445 274.178V277.365H333.966V274.178C333.966 274.095 333.95 274.013 333.918 273.936C333.886 273.859 333.84 273.79 333.781 273.731C333.722 273.672 333.653 273.626 333.576 273.594C333.499 273.562 333.417 273.546 333.334 273.546H318.168C318.085 273.546 318.003 273.562 317.926 273.594C317.85 273.626 317.78 273.672 317.721 273.731C317.663 273.79 317.616 273.859 317.584 273.936C317.552 274.013 317.536 274.095 317.536 274.178V277.365H308.057V274.178C308.057 274.095 308.041 274.013 308.009 273.936C307.977 273.859 307.931 273.79 307.872 273.731C307.814 273.672 307.744 273.626 307.667 273.594C307.591 273.562 307.508 273.546 307.425 273.546H292.259C292.176 273.546 292.094 273.562 292.017 273.594C291.941 273.626 291.871 273.672 291.812 273.731C291.754 273.79 291.707 273.859 291.675 273.936C291.644 274.013 291.627 274.095 291.627 274.178V277.365H262.559C258.536 277.365 254.679 278.962 251.835 281.807C248.99 284.651 247.393 288.508 247.393 292.53V299.388C247.393 303.41 248.99 307.267 251.835 310.111C254.679 312.955 258.536 314.553 262.559 314.553H766.834C770.856 314.553 774.714 312.955 777.558 310.111C780.402 307.267 782 303.41 782 299.388V292.53C782 288.508 780.402 284.651 777.558 281.807C774.714 278.962 770.856 277.365 766.834 277.365Z"
                      fill="#2B3440"
                    />
                  </g>
                  <g id="guy">
                    <path
                      id="Vector_18"
                      d="M56.0551 282.099L38.1248 280.903L44.1015 307.798L64.4224 299.431L56.0551 282.099Z"
                      fill="#E0B69C"
                    />
                    <path
                      id="Vector_19"
                      d="M220.417 231.895L178.58 191.254L154.672 209.782L107.455 266.559L112.835 274.926L170.212 236.079L209.061 286.879L246.117 268.352L220.417 231.895Z"
                      fill="#2F2E41"
                    />
                    <path
                      id="Vector_20"
                      opacity="0.1"
                      d="M220.417 231.895L178.58 191.254L154.672 209.782L107.455 266.559L112.835 274.926L170.212 236.079L209.061 286.879L246.117 268.352L220.417 231.895Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_21"
                      d="M224.003 258.79L218.624 262.974L174.993 248.032L164.833 243.849L144.512 248.032C144.512 248.032 144.512 231.298 163.638 231.895L183.361 236.677L206.671 238.47L224.003 258.79Z"
                      fill="#E0B69C"
                    />
                    <path
                      id="Vector_22"
                      d="M262.853 303.017L249.703 311.384H234.164L161.844 284.489L56.0549 303.614L53.0662 280.903L149.891 238.47L234.762 266.56L262.853 303.017Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_23"
                      d="M177.982 196.634L169.017 198.427L167.063 196.147C165.517 194.343 164.537 192.122 164.246 189.764C163.956 187.405 164.368 185.013 165.431 182.887L190.533 150.016C190.533 150.016 197.706 133.88 209.061 140.454C220.417 147.028 199.499 157.786 199.499 157.786L186.947 177.509L188.143 187.669L177.982 196.634Z"
                      fill="#E0B69C"
                    />
                    <path
                      id="Vector_24"
                      d="M235.31 157.617C248.183 157.617 258.619 147.182 258.619 134.309C258.619 121.436 248.183 111 235.31 111C222.436 111 212 121.436 212 134.309C212 147.182 222.436 157.617 235.31 157.617Z"
                      fill="#E0B69C"
                    />
                    <path
                      id="Vector_25"
                      d="M224 151.015L234.758 176.714L260.459 165.956C260.459 165.956 252.091 145.636 252.091 145.038C252.091 144.441 224 151.015 224 151.015Z"
                      fill="#E0B69C"
                    />
                    <path
                      id="Vector_26"
                      d="M295.074 227.538C295.074 241.606 292.857 255.585 288.505 268.962L286.76 274.329L278.393 312.579L269.427 314.97L262.853 306.602L249.704 297.04L240.141 281.501L231.941 267.838L229.383 263.571L220.417 218.747L186.35 199.622L174.994 197.829L177.384 191.255L187.545 177.509L197.706 176.313L200.694 173.923L203.085 175.118L212.648 169.739L215.636 170.934L233.112 172.56L243.727 170.337L258.992 162.143L265.244 163.165L286.76 181.095C292.261 195.961 295.076 211.687 295.074 227.538Z"
                      fill="#BACDD9"
                    />
                    <path
                      id="Vector_27"
                      d="M43.6285 291.353C43.6285 291.353 48.9817 282.28 46.7206 281.221C44.4595 280.162 34.857 275.94 34.857 275.94L20.775 271.273C20.775 271.273 0.455616 241.075 0.00960159 267.336C-0.436413 293.596 14.8046 299.908 14.8046 299.908C14.8046 299.908 28.3978 329.161 36.0977 324.496C43.7976 319.831 51.5026 303.997 51.5026 303.997C51.5026 303.997 37.6172 296.533 43.6285 291.353Z"
                      fill="#2B3440"
                    />
                    <path
                      id="Vector_28"
                      opacity="0.1"
                      d="M288.553 222.333L265.841 237.274L231.941 267.838L229.383 263.571L222.21 227.712H224.004L242.532 193.646L288.553 222.333Z"
                      fill="black"
                    />
                    <path
                      id="Vector_29"
                      d="M242.532 190.06L224.003 224.126H217.429L213.246 236.079L203.683 238.47L229.383 266.559L265.841 233.688L288.553 218.747L242.532 190.06Z"
                      fill="#BACDD9"
                    />
                    <path
                      id="Vector_30"
                      d="M216.632 117.146L214.106 118.118C213.718 117.855 213.386 117.517 213.129 117.124C212.873 116.731 212.698 116.291 212.614 115.829C212.53 115.368 212.539 114.894 212.64 114.436C212.742 113.978 212.934 113.545 213.205 113.162L208.538 112.944C211.534 108.954 215.343 105.645 219.713 103.238C224.083 100.83 228.915 99.3773 233.889 98.9765C238.862 98.5756 243.864 99.2354 248.564 100.912C253.263 102.589 257.553 105.245 261.15 108.703C261.362 107.972 263.678 109.395 264.624 110.839C264.942 109.648 267.114 115.405 267.882 119.474C268.238 118.119 269.605 120.306 268.407 122.405C269.166 122.294 269.509 124.236 268.921 125.318C269.752 124.927 269.612 127.245 268.711 128.795C269.896 128.689 259.366 145.031 255.103 154.582C253.865 148.894 252.473 142.905 248.481 138.668C247.803 137.948 247.06 137.292 246.318 136.637L242.306 133.095C237.64 128.977 233.396 123.895 227.181 122.356C222.91 121.298 220.209 121.059 222.537 116.246C220.434 117.124 218.47 118.429 216.348 119.244C216.376 118.572 216.673 117.819 216.632 117.146Z"
                      fill="#6A5440"
                    />
                    <path
                      id="Vector_31"
                      d="M246.416 141.35C248.727 141.35 250.6 139.477 250.6 137.167C250.6 134.856 248.727 132.983 246.416 132.983C244.106 132.983 242.233 134.856 242.233 137.167C242.233 139.477 244.106 141.35 246.416 141.35Z"
                      fill="#E0B69C"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
